const sections = [
  {
    number: '1',
    title: '個人情報の取得',
    content:
      '当ブログでは、お問い合わせフォームの利用、コメントの投稿、メールマガジンの登録等により、氏名、メールアドレス、その他の個人情報を取得する場合があります。',
  },
  {
    number: '2',
    title: '個人情報の利用目的',
    content: '取得した個人情報は、以下の目的で利用します。',
    list: [
      'お問い合わせやご意見への対応',
      'コメントの承認および返信',
      'メールマガジンの配信',
      'サービス向上のための分析',
      'その他、明示した利用目的',
    ],
  },
  {
    number: '3',
    title: '個人情報の第三者提供',
    content: '当ブログでは、取得した個人情報を以下の場合を除き、第三者に提供することはありません。',
    list: [
      'ご本人の同意がある場合',
      '法令に基づく場合',
      '人の生命、身体または財産の保護のために必要がある場合',
    ],
  },
  {
    number: '4',
    title: '個人情報の管理',
    content:
      '当ブログは、個人情報の正確性を保ち、これを安全に管理するために必要かつ適切な措置を講じます。不正アクセス、漏洩、紛失、破壊、改ざん等のリスクに対して、セキュリティ対策を実施しています。',
  },
  {
    number: '5',
    title: 'クッキー（Cookie）の利用',
    content:
      '当ブログでは、利用者の利便性向上およびアクセス解析のために、クッキーを使用することがあります。クッキーにより収集される情報には、個人を特定できる情報は含まれていません。',
  },
  {
    number: '6',
    title: 'アクセス解析ツール',
    content:
      '当ブログでは、Google Analyticsを利用しています。Google Analyticsはクッキーを使用してトラフィックデータを収集していますが、このデータは匿名で収集されており、個人を特定するものではありません。このデータの収集を無効にしたい場合は、ブラウザの設定でクッキーを無効にしてください。',
  },
  {
    number: '7',
    title: 'プライバシーポリシーの変更',
    content:
      '当ブログは、法令の改正や運営方針の変更に伴い、本プライバシーポリシーを変更することがあります。変更後のプライバシーポリシーは、当ブログに掲載された時点で効力を生じるものとします。',
  },
  {
    number: '8',
    title: 'お問い合わせ先',
    content:
      '本プライバシーポリシーに関するお問い合わせは、下記のメールアドレスまでお願いいたします。',
    contact: 'メールアドレス:',
  },
];

export default function PrivacyContent() {
  return (
    <main className="pt-20">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-amber-50 via-white to-amber-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <div className="inline-block px-4 py-2 bg-amber-600 text-white text-sm font-medium rounded-full mb-6">
            Privacy
          </div>
          <h1 className="text-4xl md:text-5xl font-light text-gray-900 mb-4 tracking-wide">
            プライバシーポリシー
          </h1>
          <p className="text-base text-gray-500">
            当ブログ「Angling Aquatics」における個人情報の取り扱いについて定めます。
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="space-y-10">
            {sections.map((section) => (
              <div key={section.number} className="border-b border-gray-100 pb-10 last:border-b-0">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-9 h-9 flex items-center justify-center bg-amber-100 text-amber-700 rounded-full text-sm font-semibold">
                    {section.number}
                  </div>
                  <div className="flex-1">
                    <h2 className="text-lg font-medium text-gray-900 mb-3">
                      {section.title}
                    </h2>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {section.content}
                    </p>
                    {section.list && (
                      <ul className="mt-3 space-y-1.5 pl-4">
                        {section.list.map((item, i) => (
                          <li key={i} className="flex items-start gap-2 text-sm text-gray-600">
                            <span className="mt-1.5 w-1.5 h-1.5 flex-shrink-0 rounded-full bg-amber-400"></span>
                            {item}
                          </li>
                        ))}
                      </ul>
                    )}
                    {section.contact && (
                      <p className="mt-3 text-sm text-gray-600">{section.contact}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Note */}
          <div className="mt-12 p-6 bg-amber-50/60 rounded-xl border border-amber-100">
            <p className="text-sm text-gray-600 leading-relaxed">
              ※ 本ポリシーは予告なく変更される場合があります。変更後は当ページへの掲載をもって効力を生じます。<br />
              ※ ご不明な点はお問い合わせフォームよりお気軽にご連絡ください。
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
